import "./LocationsBanner.scss";
import MainAppLocationIcon from "../icons/MainAppLocationIcon";

export default function LocationsBanner() {
  return (
    <section className={"promo-banner locations-banner"}>
      <h3>My Locations</h3>
      <p>
        Manage all your storefronts and brands from a single account. $29/mo per location, based on annual contract.
      </p>
      <div className={"circle"}>
        <MainAppLocationIcon color="#565656"/>
      </div>
    </section>
  );
}
